import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import './i18n'

// Service worker: production only. In dev it causes stale cache hell.
if ('serviceWorker' in navigator) {
  if (import.meta.env.DEV) {
    // Unregister any existing SW in dev so you never need Ctrl+Shift+R
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const reg of registrations) {
        reg.unregister();
        console.log('Service Worker: Unregistered (dev mode)');
      }
    });
  } else {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          // Check for updates every 60 seconds
          setInterval(() => registration.update(), 60000);

          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'activated') {
                  console.log('Service Worker: New version activated');
                }
              });
            }
          });
        })
        .catch((error) => {
          console.error('Service Worker: Registration failed', error);
        });
    });
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
) 